module.exports = __webpack_public_path__ + "media/images/case-studies/wandiful-23f8b7625ef4bfc5b4c3b9977708fc4c.png";